const pluginName = 'SetActiveLink';
const defaults = {
  activeClass: 'is-active'
};

const setActiveLink = (parentElement, inputOptions) => {
  if (!parentElement || !(parentElement instanceof HTMLElement)) return;

  const options = {
    ...defaults,
    inputOptions
  };

  const links = parentElement.querySelectorAll('a');
  const { location } = window;

  links.forEach(link => {
    const hrefUrl = new URL(link.getAttribute('href'), `${location.protocol}//${location.host}`);
    if (hrefUrl.host === location.host && hrefUrl.pathname === location.pathname) {
      link.classList.add(options.activeClass);
    }
  });
};

if (window.jQuery) {
  $.fn[pluginName] = function plugin(options) {
    this.each(function each() {
      setActiveLink(this, options);
    });
  };
}

export default setActiveLink;
